import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export default function QrLanding() {
  const { shortcode } = useParams<{ shortcode: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [member, setMember] = useState<{ first_name: string | null; una_name: string | null } | null>(null);

  useEffect(() => {
    const load = async () => {
      if (!shortcode) {
        setLoading(false);
        return;
      }
      const { data, error } = await supabase.functions.invoke("qr-landing", {
        body: { shortcode },
      });
      if (!error && data && (data as any).first_name !== undefined) {
        setMember(data as any);
      }
      setLoading(false);
    };
    void load();
  }, [shortcode]);

  if (loading) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!member) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center px-4">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6 space-y-4 text-center">
            <h1 className="text-xl font-semibold">We could not match that code</h1>
            <p className="text-sm text-muted-foreground">
              No trouble at all. Sign in with your email and everything will be waiting for you.
            </p>
            <Button className="w-full" onClick={() => navigate("/login")}>Sign in</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-4 py-10">
      <Card className="w-full max-w-lg">
        <CardContent className="pt-8 space-y-5 text-center">
          <p className="text-sm uppercase tracking-widest text-muted-foreground">
            {member.una_name || "Your Association"}
          </p>
          <h1 className="text-3xl font-bold">
            {member.first_name ? `${member.first_name}, your documents have arrived.` : "Your documents have arrived."}
          </h1>
          <p className="text-muted-foreground">
            Welcome home. Everything you need is in your hands now. We will walk you through the first steps together.
          </p>
          <Button size="lg" className="w-full" onClick={() => navigate("/journey")}>
            Begin My Journey
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
